import React from 'react';

const NotFound = ({history}) => (
  <div className='error-page'>
    <div className='error-page-img'/>
    <p className='error-page-title'>Такой страницы не существует</p>
    <p>Самые верояные причины:</p>
    <p className='error-page-grey'>- ошибка в адресе, устаревшая ссылка, страница удалена автором</p>
    <p className='error-page-grey'>Вы можете вернуться <a className="link" role="link" onClick={() => history.goBack()}>Назад</a>, перейти на <a className="link" role="link" onClick={() => history.push('/lk')}>Главную</a><br/>
      </p>
      {/* или попробовать найти нужную Вам страницу
    <form action="">
      <input type="text"/>
      <button/>
    </form> */}
  </div>
);

export default NotFound;

